const initArticleRelatedProductsSwiper = (root) => {
  if (typeof window.Swiper !== 'function') return;
  if (!root) return;

  const container = root.querySelector('[data-swiper-init]');
  if (!container) return;

  const wrap = container.querySelector('.article-related-products__swiper-wrap');
  const swiperEl =
    container.querySelector('.article-related-products__swiper-inner') ||
    container.querySelector('.swiper');

  if (!wrap || !swiperEl || !swiperEl.querySelector('.swiper-wrapper')?.children.length) return;
  if (swiperEl.classList.contains('swiper-initialized') || swiperEl.swiper) return;

  const gapAttr = Number.parseInt(root.dataset.columnsGap || '20', 10);
  const gapNum = Number.isFinite(gapAttr) ? gapAttr : 20;
  const prevEl = wrap.querySelector('.article-related-products__arrow--prev');
  const nextEl = wrap.querySelector('.article-related-products__arrow--next');
  const paginationEl = wrap.querySelector('.article-related-products__pagination');

  new window.Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: gapNum,
    navigation: prevEl && nextEl ? { nextEl, prevEl } : false,
    pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
    breakpoints: {
      0: { spaceBetween: Math.min(gapNum, 15) },
      750: { spaceBetween: gapNum }
    },
    on: {
      init() {
        swiperEl.classList.add('swiper-initialized');
        if (this.isBeginning && this.isEnd) {
          wrap.classList.add('article-related-products__swiper-wrap--no-nav');
        }
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.article-related-products[data-section-id]').forEach((root) => {
    initArticleRelatedProductsSwiper(root);
  });
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches('.article-related-products[data-section-id]')) {
    initArticleRelatedProductsSwiper(event.target);
  }
});
